import axios from 'axios';


function logError(error) {
	console.log(error);
	throw error;
}

class ParkService {
	getParkPageData(language) {
		return axios
			.post(
				`${process.env.REACT_APP_API_ENDPOINT}/api/singletons/get/Park?lang=${language}`,
				{
					populate: 2,
					lang: language,
				},
			)
			.then(res => res)
			.catch(logError);
	}
}

export default new ParkService();
